<template>
  <div>
    <!--    <el-form-item-->
    <!--      class="custom-label__input width25"-->
    <!--      label="Thông tin bay"-->
    <!--      prop="flightUserList"-->
    <!--    >-->
    <!--      <div class="flex-row flex__left"></div>-->
    <!--    </el-form-item>-->
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="userRoutes"
        v-if="userRoutes && userRoutes.length"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <hc-maybay-user-route-extend-info
              :userRoute="props.row"
            ></hc-maybay-user-route-extend-info>
          </template>
        </el-table-column>

        <el-table-column label="Họ tên/Chặng bay">
          <template slot-scope="scope">
            <hc-maybay-user-route-hoten-changbay
              :userRoute="scope.row"
            ></hc-maybay-user-route-hoten-changbay>
          </template>
        </el-table-column>

        <el-table-column label="Thời gian bay thực tế/Số vé" min-width="80">
          <template slot-scope="scope">
            <div class="flex-row flex__left margin-right-10">
              <el-row :gutter="24">
                <el-col :span="24" class="flex-row flex__left">
                  <i class="el-icon-time color__blue margin-right-5"></i>
                  <el-date-picker
                    class="style-fullWidth input-none__border input-inner-table inputBg__white"
                    v-model="scope.row.flightTimeRealistic"
                    type="datetime"
                    size="medium"
                    :prefix-icon="' '"
                    placeholder="dd/mm/yyyy HH:mm"
                    format="dd/MM/yyyy HH:mm"
                  ></el-date-picker>
                </el-col>

                <el-col :span="24" class="margin-top-5 flex-row flex__left">
                  <span class="margin-right-5">#&nbsp;</span>
                  <el-input
                    class="style-fullWidth input-none__border input-inner-table inputBg__white"
                    placeholder="Số vé máy bay"
                    size="medium"
                    v-model="scope.row.ticketNumber"
                    maxlength="100"
                    show-word-limit
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import dateFormatter from "../../../filters/dateFormatter";
import hcCaseFlightRouteUserViewService from "../../../services/maybay/hcCaseFlightRouteUserViewService";
import BreakWordSpan from "../ketluan/break-word-span";
import h from "../../../services/h";
import HcMaybayUserRouteExtendInfo from "./hc-maybay-user-route-extend-info";
import HcMaybayUserRouteHotenChangbay from "./hc-maybay-user-route-hoten-changbay";

export default {
  name: "hc-maybay-user-route",
  mixins: [handleRequestErrorMixin],
  filters: {dateFormatter},
  components: {HcMaybayUserRouteHotenChangbay, HcMaybayUserRouteExtendInfo, BreakWordSpan},
  props: ["hcCaseMasterId"],

  data() {
    return {
      userRoutes: []
    };
  },

  watch: {
    hcCaseMasterId() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    getData() {
      return h.collect(this.userRoutes, item => {
        return {
          id: item.id,
          ticketNumber: item.ticketNumber,
          flightTimeRealistic: item.flightTimeRealistic
            ? item.flightTimeRealistic.getTime()
            : null
        };
      });
    },

    loadUserRoutes() {
      return hcCaseFlightRouteUserViewService
        .findAllByHcCaseMasterId(this.hcCaseMasterId)
        .then(response => {
          this.userRoutes = h.collect(
            response.data,
            hcCaseFlightRouteUserView => {
              return {
                id: hcCaseFlightRouteUserView.id,
                caseMasterId: hcCaseFlightRouteUserView.caseMasterId,
                flightRouteId: hcCaseFlightRouteUserView.flightRouteId,
                flightUserId: hcCaseFlightRouteUserView.flightUserId,
                ticketNumber: hcCaseFlightRouteUserView.ticketNumber,
                flightTimeEstimate:
                hcCaseFlightRouteUserView.flightTimeEstimate,
                flightTimeRealistic: hcCaseFlightRouteUserView.flightTimeRealistic
                  ? new Date(hcCaseFlightRouteUserView.flightTimeRealistic)
                  : null,
                createTime: hcCaseFlightRouteUserView.createTime,
                updateTime: hcCaseFlightRouteUserView.updateTime,
                userName: hcCaseFlightRouteUserView.userName,
                gender: hcCaseFlightRouteUserView.gender,
                birthday: hcCaseFlightRouteUserView.birthday,
                isdn: hcCaseFlightRouteUserView.isdn,
                BSVNumber: hcCaseFlightRouteUserView.BSVNumber,
                identityNumber: hcCaseFlightRouteUserView.identityNumber,
                positionId: hcCaseFlightRouteUserView.positionId,
                positionName: hcCaseFlightRouteUserView.positionName,
                deptId: hcCaseFlightRouteUserView.deptId,
                deptName: hcCaseFlightRouteUserView.deptName,
                email: hcCaseFlightRouteUserView.email,
                airportFromId: hcCaseFlightRouteUserView.airportFromId,
                placeNameFrom: hcCaseFlightRouteUserView.placeNameFrom,
                airportToId: hcCaseFlightRouteUserView.airportToId,
                placeNameTo: hcCaseFlightRouteUserView.placeNameTo
              };
            }
          );
        });
    },

    reloadData() {
      this.loadUserRoutes();
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-user-route.vue